import { render, staticRenderFns } from "./LoginWay.vue?vue&type=template&id=31ffde64&scoped=true&"
import script from "./LoginWay.vue?vue&type=script&lang=js&"
export * from "./LoginWay.vue?vue&type=script&lang=js&"
import style0 from "./LoginWay.vue?vue&type=style&index=0&id=31ffde64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ffde64",
  null
  
)

export default component.exports